/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LinkPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABzklEQVR4nOVWy0rsQBCN770vUOEiiOBfzDZguqoitFXBF6JGQf9h1n6SG1FHRQcVxLu4XF2KiKK/oFQePjIzyRhxZUFvUt3nVJ96dBzn11kYhj2IwTog1wzKU7RIDgxxqL5vgfv+3Aig1IHkpdkyyKe+Pz9cChxARg3JvxiM7xGDVSKe8GaCKUO8BcSPkQ+lXqlUukuDG+IL19qh7B5EHle5kj1h2+DVarUTiP8m0Z1ba/tbBuLLZkwg+18jQLkC5OM8cDWVLJHw2fkJm54JJuNky1P+xmk7FsmCvJf1eV4wCCg7QLyd9an2iUQH+eDI/2PNudYATnyZ5GOngQDlRn3aJy2r5R38c0Jda4fewIkvlSxzvEP7QINqWqbW2l5DfFYSvNiAZCPpxjuihYH0u7W2Swm/BR4RoBxGIDC7+PG767p9QHKrJHnghuQom7PMDfhZCTTJWZ/run1F7Z/Oo0ICz7N/8oBKE2jtJjW85JQwKL6BrCWbbnUsNxsZzueAjlqN7bf1MSf6WBjik7SSAGaXNR8qmUFeAZJrnUla71FAyLUigoaO1npPSdo68BWJUtNq0YgNyS6gPMSL9/SByauktgnK2s8T6E9AEwlfAa0RPIdkroUBAAAAAElFTkSuQmCC)
 */
export const LinkPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M11.8 3.75a5.98 5.98 0 0 1 8.98 7.85 1 1 0 0 1-1.6-1.21 3.98 3.98 0 0 0-5.97-5.22l-2.51 2.5a1 1 0 1 1-1.42-1.4l2.52-2.52ZM7.68 9.28a1 1 0 0 1 0 1.42L5.17 13.2a3.98 3.98 0 0 0 5.22 5.98 1 1 0 1 1 1.21 1.59 5.98 5.98 0 0 1-7.85-8.98l2.52-2.52a1 1 0 0 1 1.4 0Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M14.7 10.7a1 1 0 0 0-1.4-1.4l-4 4a1 1 0 1 0 1.4 1.4l4-4ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
